var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button__content d-flex justify-content-center align-items-center",class:{hover: _vm.parentHover},on:{"click":_vm.btnClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }